import { z } from 'zod';

import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';
import { createVatNumberFieldValidator } from '@features/users/adminPanel/utils/vatValidators.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';

interface SchemaParams {
  countryCode: UserCountryCode;
}

export function createFormSchema({ countryCode }: SchemaParams) {
  return z.object({
    [FormFields.INVOICING_EMAIL]: z
      .string({
        required_error: 'errorMessages.required',
      })
      .email({
        message: 'errorMessages.invalidEmail',
      }),
    [FormFields.VAT_NUMBER]: createVatNumberFieldValidator(countryCode),
  });
}

export type FormValues = z.infer<ReturnType<typeof createFormSchema>>;
